module.exports = "<div class=\"snackbar\" [ngClass]=\"data.type\">\n  <mat-icon>report_problem</mat-icon>{{data.message}}\n</div>\n"